export default {
  label: 'Checked posts',
  placeholder: 'All',
  items: {
    all: 'All',
    onlyChecked: 'Only Checked',
    onlyUnchecked: 'Only Unchecked',
  },
};
